import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Recipient from '../Sections/Recipient/Recipient';
import { commitMutation, graphql } from 'react-relay';
import { Analytics, GlobalNotifications, Intent } from '../../Modules';
import nullifyEmptyStrings from '../../../lib/utils/nullifyEmptyStrings';

export default class EstimateRecipient extends React.Component {

  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      localRecipient: this.getRecipientFromEstimate()
    };
    this.getRecipientFromEstimate = this.getRecipientFromEstimate.bind(this);
    this.updateRecipient = this.updateRecipient.bind(this);
    this.resetRecipient = this.resetRecipient.bind(this);
    this.recipientChangeHandler = this.recipientChangeHandler.bind(this);
  }

  getRecipientFromEstimate() {
    return _.pick(this.props.node, [
      'recipient_first_name',
      'recipient_last_name',
      'recipient_company_name',
      'recipient_email',
      'recipient_phone',
      'recipient_address'
    ]);
  }

  updateRecipient(successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to update recipient information',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully updated recipient information',
        intent: Intent.SUCCESS
      });
      Analytics.trackEvent('updated-recipient');
    };

    const localRecipient = nullifyEmptyStrings(this.state.localRecipient);
    const phone = localRecipient.recipient_phone;
    localRecipient.recipient_phone = phone ? phone.replace(/\D/g, '') : null;

    const mutation = graphql`
      mutation Recipient_updateEstimateMutation(
        $input: UpdateEstimateInput!
      ) {
        updateEstimate(input: $input) {
          estimate {
            id
            recipient_first_name
            recipient_last_name
            recipient_company_name
            recipient_email
            recipient_phone
            recipient_address
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          id: this.props.node.id,
          ...localRecipient
        }
      },
      onCompleted,
      onError
    });
  }

  resetRecipient() {
    const obj = _.cloneDeep(this.state);
    obj.localRecipient = this.getRecipientFromEstimate();
    this.setState(obj);
  }

  recipientChangeHandler(recipient) {
    const obj = _.cloneDeep(this.state);
    obj.localRecipient = recipient;
    this.setState(obj);
  }

  render() {
    return (
      <Recipient
        canEdit={this.props.canEdit}
        recipient={this.getRecipientFromEstimate()}
        resetRecipient={this.resetRecipient}
        localRecipient={this.state.localRecipient}
        onChange={this.recipientChangeHandler}
        updateRecipient={this.updateRecipient}
        viewer={this.props.viewer}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/Recipient.js